// Quick View - lazy loader to avoid parsing heavy modal logic on first paint
(function () {
  let quickViewScriptPromise = null;

  function getQuickViewScriptUrl() {
    if (window.themeAssets && window.themeAssets.quickViewJS) {
      return window.themeAssets.quickViewJS;
    }

    const scriptTag = document.querySelector(
      'script[src*="quick-view-loader.js"]',
    );
    if (!scriptTag || !scriptTag.src) {
      return null;
    }

    return scriptTag.src.replace("quick-view-loader.js", "quick-view-modal.js");
  }

  function ensureQuickViewLoaded() {
    if (typeof window.openQuickViewOriginal === "function") {
      return Promise.resolve();
    }

    if (quickViewScriptPromise) {
      return quickViewScriptPromise;
    }

    quickViewScriptPromise = new Promise((resolve, reject) => {
      const src = getQuickViewScriptUrl();
      if (!src) {
        reject(new Error("Unable to resolve quick-view-modal.js URL"));
        return;
      }

      const existing = document.querySelector(`script[src="${src}"]`);
      if (existing) {
        if (typeof window.openQuickViewOriginal === "function") {
          resolve();
          return;
        }

        existing.addEventListener("load", resolve, { once: true });
        existing.addEventListener(
          "error",
          () => reject(new Error("Failed to load quick-view-modal.js")),
          { once: true },
        );
        return;
      }

      const script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () =>
        reject(new Error("Failed to load quick-view-modal.js"));
      document.head.appendChild(script);
    });

    return quickViewScriptPromise;
  }

  window.openQuickView = function (productHandle) {
    ensureQuickViewLoaded()
      .then(() => {
        if (typeof window.openQuickViewOriginal === "function") {
          window.openQuickViewOriginal(productHandle);
        } else {
          console.error("Quick view modal did not initialize correctly");
        }
      })
      .catch((error) => {
        console.error("Failed to open quick view:", error);
      });
  };

  window.closeQuickView = function () {
    if (typeof window.closeQuickViewOriginal === "function") {
      window.closeQuickViewOriginal();
    }
  };
})();
